<template>
  <div class="no-shadow no-parent-padding">
    <b-card no-body>
      <b-card-header class="d-inline-flex py-1 bg-transparent border-bottom-0">
        <h2 class="mb-0 align-self-center">
          Traduções do termo
          <span v-if="!!termo" class="text-muted font-weight-500">
            · {{ termo.rotulo }}
          </span>
        </h2>
        <b-button class="ml-auto" :to="{ name: 'termos_filtros_list' }">
          Voltar para termos
        </b-button>
      </b-card-header>
      <div v-if="isFetching" class="text-center">
        <b-spinner label="Carregando traduções" />
      </div>
      <b-alert :show="isError" variant="danger">
        Não foi possível carregar as traduções deste termo.
        <b-button size="sm" @click="refetch">Tentar novamente</b-button>
      </b-alert>
      <div v-if="!isFetching && !isError && termo" class="card-body">
        <p>
          <span class="d-block"> Termo original em Português do Brasil </span>
          Salve cada idioma após editar. Sem tradução, será exibido o termo
          original.
        </p>
        <TraducaoField
          v-for="idioma in resultado.idiomas"
          :key="`${tipo}-${termo.id}-${idioma}`"
          :tipo="tipo"
          :termo-id="String(termo.id)"
          :idioma="idioma"
          :label="idiomasLabels[idioma] || idioma"
          :traducao="termo.traducoes[idioma] || null"
          @state-change="updateState(idioma, $event)"
        />
      </div>
      <b-alert :show="!isFetching && !isError && !termo" variant="warning">
        Este termo não foi encontrado.
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import { computed, defineComponent, ref, set } from "vue";
import { useRoute } from "vue-router/dist/composables.js";
import { useQuery } from "@/composables/useQuery";
import TraducaoField from "../Components/TraducaoField.vue";
import services from "@/http";
import { IDIOMAS_LABELS } from "../idiomas";
import { useEventListener } from "@vueuse/core";

export default defineComponent({
  name: "TermosFiltrosEdit",
  components: { TraducaoField },
  beforeRouteLeave(to, from, next) {
    next(this.canLeave());
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.canLeave()) return next(false);

    this.states = {};
    next();
  },
  setup() {
    const route = useRoute();
    const tipo = computed(() => route.params.tipo);
    const states = ref({});
    const {
      data: resultado,
      isFetching,
      isError,
      refetch,
    } = useQuery({
      key: ["termos-filtros", "editar", tipo],
      queryFn: () => services.termos_filtros.get_itens({ tipo: tipo.value }),
      select: (response) => response.data,
    });
    const termo = computed(() =>
      resultado.value?.tipo === tipo.value
        ? resultado.value.itens.find(
            (item) => String(item.id) === String(route.params.id)
          )
        : null
    );
    const busy = computed(() =>
      Object.values(states.value).some((state) => state.busy)
    );
    const dirty = computed(() =>
      Object.values(states.value).some((state) => state.dirty)
    );

    function updateState(idioma, state) {
      set(states.value, idioma, state);
    }

    function canLeave() {
      if (busy.value) return false;

      return (
        !dirty.value ||
        window.confirm(
          "Existem alterações não salvas. Deseja sair e descartá-las?"
        )
      );
    }

    function beforeUnload(event) {
      if (!busy.value && !dirty.value) return;

      event.preventDefault();
      event.returnValue = "";
    }

    useEventListener("beforeunload", beforeUnload);

    return {
      tipo,
      states,
      resultado,
      termo,
      isFetching,
      isError,
      refetch,
      idiomasLabels: IDIOMAS_LABELS,
      canLeave,
      updateState,
    };
  },
});
</script>
